const organicChecklist_crop = [
    {
        "category": "01",
        "chineseText": "1.基本資料",
        "englishText": "1.General Information",
        "chineseDisplay": "基本資料",
        "englishDisplay": "General Information",
        "items": [
            {
                "code": "01-1",
                "chineseText": "1.1 查驗過程中經營者/聯絡人是否全程陪同？陪查人員姓名及職稱。",
                "englishText": "1.1 Was the owner/manager/organic contact person present for the entire inspection？List the person(s)name and job title."
            },
            {
                "code": "01-2",
                "chineseText": "1.2 作物驗證申請書(以下簡稱申請書)的農場基本資料是否完整？請說明任何異動部份。",
                "englishText": "1.2 Are data complete in general information in Organic System Plan (hereafter OSP)? Explain any changes."
            },
            {
                "code": "01-3",
                "chineseText": "1.3 經營者是否擁有一份本公司現行的有機標準?",
                "englishText": "1.3 Does this entity have a copy of current Organic Standards applied for?"
            },
            {
                "code": "01-4",
                "chineseText": "1.4 除了目前所申請的標準外，申請者是否同時申請或已通過其它有機標準？如有，請說明。",
                "englishText": "1.4 Besides the standard is applying for, does the applicant also have applied for or certified by other organic standards? If yes, please describe."
            },
            {
                "code": "01-5",
                "chineseText": "1.5 申請書是否提及其他有機驗證機構驗證資格與不合格通知或要求？?",
                "englishText": "1.5 Is notification or requirement of passing or failing certification by other control body stated in the OSP?"
            },
            {
                "code": "01-6",
                "chineseText": "1.6 申請者若以前有驗證過，申請書中是否檢附矯正計畫和文件證明?",
                "englishText": "1.6 If applicant has been certified before, are corrective actions and document proof attached with the OSP?"
            },
            {
                "code": "01-7",
                "chineseText": "1.7 請簡述查驗之作物種類、農地、建築物、倉庫或設備。",
                "englishText": "1.7 Please briefly describe type of crops, farmland, buildings, storages or equipment under inspection."
            },
            {
                "code": "01-8",
                "chineseText": "1.8 需補充的文件是否有在現場提供？",
                "englishText": "1.8 Are supplementary documents required on site?"
            }
        ]
    },
    {
        "category": "02",
        "chineseText": "2.農場計畫資訊",
        "englishText": "2.Farm Plan Information",
        "chineseDisplay": "農場計畫資訊",
        "englishDisplay": "Farm Plan Information",
        "items": [
            {
                "code": "02-1",
                "chineseText": "2.1 農地歷史表是否記載所有投入資材及日期？",
                "englishText": "2.1 Do field history sheets show all inputs and dates applied?"
            },
            {
                "code": "02-2",
                "chineseText": "2.2 農地歷史表是否涵蓋所有田區？",
                "englishText": "2.2 Do field history sheets include all fields?"
            },
            {
                "code": "02-3",
                "chineseText": "2.3 申請驗證總面積與申請書所述是否相符？",
                "englishText": "2.3 Does total acreage require certification same as OSP?"
            },
            {
                "code": "02-4",
                "chineseText": "2.4 農場圖上是否正確顯示下列各點？ a. 田區  b. 田區代號  c.鄰近土地用途  d. 水源 e. 緩衝帶 f. 農場圖是否明確標示出堆肥房舍？（未標示者請圈選）",
                "englishText": "2.4 Are following points correctly indicated on the map: a. fields, b. field no, c. adjoining land use, d. water source, e. buffer zones, f. " +
                    "Are compost houses accurately marked on farm map? (If not, please circle them.)"
            },
            {
                "code": "02-5",
                "chineseText": "2.5 經營未達3年之農地，是否有以前經營者或持有者所提供有關前三年使用資材的署名文件? (僅NOP適用)",
                "englishText": "2.5 For fields managed less than three years, was a signed statement from the previous manager " +
                    "or owner stating the use and all inputs applied for the previous three years obtained? (For NOP only)"
            },
            {
                "code": "02-6",
                "chineseText": "2.6 其他意見或觀察。",
                "englishText": "2.6 Other comments or observations."
            }
        ]
    },
    {
        "category": "03",
        "chineseText": "3.種子及種子處理",
        "englishText": "3.Seeds and Seed Treatments",
        "chineseDisplay": "種子及種子處理",
        "englishDisplay": "Seeds and Seed Treatments",
        "items": [
            {
                "code": "03-1",
                "chineseText": "3.1 申請書的 “種子資訊“是否完整正確?",
                "englishText": "3.1 Is “seeds information” of the OSP complete and accurate?"
            },
            {
                "code": "03-2",
                "chineseText": "3.2 是否所有種子皆為有機? 若否，請列出所有的非有機種子",
                "englishText": "3.2 Are all seeds organic? If no, list all non-organic seeds."
            },
            {
                "code": "03-3",
                "chineseText": "3.3 若使用非有機種子，是否具有“商業上無法取得”或其相關文件?",
                "englishText": "3.3 If non-organic seeds being used, is “commercially not available” or related documents available?"
            },
            {
                "code": "03-4",
                "chineseText": "3.4 是否所有種子皆未經禁用物質處理? 若否，應列出處理方法及所使用禁用物質。",
                "englishText": "3.4 Do all seeds free from prohibited treatments? If no, list treatments and prohibited materials applied."
            },
            {
                "code": "03-5",
                "chineseText": "3.5 非有機種子及其處理方式是否為非基因改造產品?",
                "englishText": "3.5 Are all non-organic seeds and treatment being verified as Non-GMO?"
            },
            {
                "code": "03-6",
                "chineseText": "3.6 種子是否有標示詳實? 若否，請說明種子來源。",
                "englishText": "3.6 Did you verify labels of all seeds? If no, please the source of seeds."
            },
            {
                "code": "03-7",
                "chineseText": "3.7 其他意見或觀察。",
                "englishText": "3.7 Other comments or observations."
            },
        ]
    },
    {
        "category": "04",
        "chineseText": "4.種苗及多年生苗木來源",
        "englishText": "4.Source of Seedlings and Perennial Stock",
        "chineseDisplay": "種苗及多年生苗木來源",
        "englishDisplay": "Source of Seedlings and Perennial Stock",
        "items": [
            {
                "code": "04-1",
                "chineseText": "4.1 是否申請書的“種苗及多年生苗木來源” 完整及正確？",
                "englishText": "4.1 Is “Source of Seedlings and Perennial Stock” of the OSP complete and accurate?"
            },
            {
                "code": "04-2",
                "chineseText": "4.2 若使用非有機種苗或多年生苗木(購買或種植的) ，是否業者保有「有機種苗或多年生苗木市面無法獲得」相關文件?",
                "englishText": "4.2 If use nonorganic seedlings or perennial stock (purchased or grown), is “commercially not available” documentation maintained？"
            },
            {
                "code": "04-3",
                "chineseText": "4.3 若使用非有機多年生苗木，於收穫或販賣之前，該植株是否曾受有機方式管理（至少一年）使其為有機驗證苗木。",
                "englishText": "4.3 If use nonorganic perennial stock, were they managed organically for at least one year prior to harvest of crop or sale of the plant " +
                    "as certified organic planting stock."
            },
            {
                "code": "04-4",
                "chineseText": "4.4 種苗及多年生苗木若經禁用物質處理，作物農藥殘留是否符合要求?",
                "englishText": "4.4 If prohibited treatment has been used on seedlings and perennial stock, does crop pesticide residue meet requirements?"
            },
            {
                "code": "04-5",
                "chineseText": "4.5 是否申請書之溫室資訊完整及正確?",
                "englishText": "4.5 Is the “greenhouse” information of the OSP complete and accurate?"
            },
            {
                "code": "04-6",
                "chineseText": "4.6 使用允用物質時，是否依照其標示說明?",
                "englishText": "4.6 Are allowed materials being used according to the instruction on labels?"
            },
            {
                "code": "04-7",
                "chineseText": "4.7 其他意見或觀察。",
                "englishText": "4.7 Other comments or observations."
            },
        ]
    },
    {
        "category": "05",
        "chineseText": "5.土壤及作物肥力管理",
        "englishText": "5.Soil and Crop Fertility Management",
        "chineseDisplay": "土壤及作物肥力管理",
        "englishDisplay": "Soil and Crop Fertility Management",
        "items": [
            {
                "code": "05-1",
                "chineseText": "5.1 申請書之「土壤及作物肥力管理（包括監測）」是否完整及正確？",
                "englishText": "5.1 Is “Soil and Crop Fertility Management (including monitoring)” of the OSP complete and accurate?"
            },
            {
                "code": "05-2",
                "chineseText": "5.2 是否作物肥力管理能維護或改善土壤之物理、化學及生物條件？",
                "englishText": "5.2 Does the Crop Fertility Management maintain or improve the physical, chemical, and biological condition of soil?"
            }
        ]
    },
    {
        "category": "06",
        "chineseText": "6.作物管理",
        "englishText": "6.Crop management",
        "chineseDisplay": "作物管理",
        "englishDisplay": "Crop management",
        "items": [
            {
                "code": "06-1",
                "chineseText": "6.1 申請書之「土壤及作物肥力管理（包括監測）」是否完整及正確？",
                "englishText": "6.1 Is crop rotation explained in the OSP?"
            },
            {
                "code": "06-2",
                "chineseText": "6.2 輪作是否包含許多不同作物？請描述有多少作物種類。",
                "englishText": "6.2 Does crop rotation include a variety of crops? Describe how many kinds."
            }
        ]
    },
    {
        "category": "07",
        "chineseText": "7.有機完整性之保持",
        "englishText": "7.Maintenance of Organic Integrity",
        "chineseDisplay": "有機完整性之保持",
        "englishDisplay": "Maintenance of Organic Integrity",
        "items": [
            {
                "code": "07-1",
                "chineseText": "7.1 申請書上是否詳述緩衝區管理策略、特殊有機生產區、緩衝作物區位置、鄰地使用、通知書及監控法？",
                "englishText": "7.1 Are buffer zone management strategies, specific organic production area, type of buffer zone, adjoining lands use, " +
                    "letter of notification and monitor methods accurately described in the OSP?"
            },
            {
                "code": "07-2",
                "chineseText": "7.2 農場圖是否有標示出緩衝帶及鄰地使用位置？",
                "englishText": "7.2 Are buffer zones and adjoining land use marked in the farm map?"
            }
        ]
    },
    {
        "category": "08",
        "chineseText": "8.紀錄維護系統",
        "englishText": "8.Record Keeping",
        "chineseDisplay": "紀錄維護系統",
        "englishDisplay": "Record Keeping",
        "items": [
            {
                "code": "08-1",
                "chineseText": "8.1 申請書內經營者是否列出所有必須保存之紀錄？",
                "englishText": "8.1 Do manager/operators list all records to be kept in the OSP?"
            },
            {
                "code": "08-2",
                "chineseText": "8.2 經營者是否保存並維持農地工作紀錄？",
                "englishText": "8.2 Do manager/operators keep and maintain farm working records?"
            }
        ]
    },
    {
        "category": "09",
        "chineseText": "9.採樣",
        "englishText": "9.Sampling",
        "chineseDisplay": "採樣",
        "englishDisplay": "Sampling",
        "items": [
            {
                "code": "09-1",
                "chineseText": "9.1 請說明查驗期間所作採樣或未來採樣之建議（具體說明）。",
                "englishText": "9.1 Describe suggestions on sampling during inspection or future sampling (specifically)."
            },
            {
                "code": "09-2",
                "chineseText": "9.2 其他意見或觀察。",
                "englishText": "9.2 Other comments or observations."
            }
        ]
    },
    {
        "category": "10",
        "chineseText": "10.栽培集團適用",
        "englishText": "10.For Grower Group Only",
        "chineseDisplay": "栽培集團適用",
        "englishDisplay": "For Grower Group Only",
        "items": [
            {
                "code": "10-1",
                "chineseText": "10.1 是否所有班員(成員或組員)統一由共同的培訓方案來培訓？",
                "englishText": "10.1 Are all members unified by a shared training regimen？"
            },
            {
                "code": "10-2",
                "chineseText": "10.2 是否所有班員(成員或組員)的生產操作方式均遵行集團作業申請書上的描述，包括投入資材、肥料與病蟲害管理、衛生管理、紀錄保存與追溯稽核系統？",
                "englishText": "10.2 Do all members operate together under the same section of the producer group operation’s single Organic System Plan, including inputs used, " +
                    "fertility management and pest control practices, and health care practices, and record keeping and audit trail system.?"
            }
        ]
    },
    {
        "category": "11",
        "chineseText": "11.機密性、簽署及附件",
        "englishText": "11.Confidentiality, Signature, and Exhibits",
        "chineseDisplay": "機密性、簽署及附件",
        "englishDisplay": "Confidentiality, Signature, and Exhibits",
        "items": [
            {
                "code": "11-1",
                "chineseText": "11.1 若適用，請列出所有顧慮或未來可能無法符合相關法規事項。",
                "englishText": "11.1 If applicable, list all items in concern or items that may not be complied with in future and write down specific regulations."
            },
            {
                "code": "11-2",
                "chineseText": "11.2 其他意見或觀察。",
                "englishText": "11.2 Other comments or observations."
            }
        ]
    }
]

export default organicChecklist_crop